<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-absolute"
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <img :src="sharklogo" alt="Shark-Logo" class="sharklogo" />
        <h5 class="title">Skimboards handcrafted in Malta.</h5>
      </div>
      <div class="md-toolbar-section-end">
        <md-button id="menuButton"
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list>
              <md-list-item href="#/">
                <i class="material-icons">home</i>
                <p>Home</p>
                <md-tooltip md-direction="bottom" md-active.sync="tooltipActive">
                  Home.
                </md-tooltip>
              </md-list-item>

              <md-list-item href="#/about">
                <i class="material-icons">info</i>
                <p>About</p>
                <md-tooltip md-direction="bottom" md-active.sync="tooltipActive">
                  About JS Skimboards.
                </md-tooltip>
              </md-list-item>

              <md-list-item href="#/gallery">
                <i class="material-icons">collections</i>
                <p>Gallery</p>
                <md-tooltip md-direction="bottom" md-active.sync="tooltipActive">
                  Gallery of JS Skimboards.
                </md-tooltip>
              </md-list-item>

              <md-list-item
                href="https://www.facebook.com/Skimboards-Malta-101873865456675"
                target="_blank"
              >
                <i class="fab fa-facebook-square"></i>
                <p class="hidden-lg">Facebook</p>
                <md-tooltip md-direction="bottom" md-active.sync="tooltipActive">
                  Like us on Facebook.
                </md-tooltip>
              </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;

function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import MobileMenu from "@/layout/MobileMenu";
export default {
  components: {
    MobileMenu
  },
  props: {
    sharklogo: {
      type: String,
      default: require("@/assets/img/shark-logo.png")
    },
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false,
      tooltipActive: false
    };
  },
  methods: {
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.bodyClick();
    },
    handleScroll() {
        let scrollValue =
          document.body.scrollTop || document.documentElement.scrollTop;
        let navbarColor = document.getElementById("toolbar");
        this.currentScrollValue = scrollValue;
        if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
          this.extraNavClasses = `md-${this.type}`;
          navbarColor.classList.remove("md-transparent");
        } else {
          if (this.extraNavClasses) {
            this.extraNavClasses = "";
            navbarColor.classList.add("md-transparent");
          }
        }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  }
};
</script>
<style lang="scss">
.sharklogo {
  width: 10%;
  height: 20%;
  transform: rotate(-25deg);
}
@media (max-width: 768px){
  .sharklogo {
    width: 40%;
    height: 80%;
    transform: rotate(-25deg);
  }
}
</style>
